// application-pipes.module.ts
// other imports
import { SafePipe } from "./safe-html.pipe";
import { TimePipe } from "./time.pipe";
import { NgModule } from "@angular/core";
import { DateTimePipe } from "./datetime.pipe";

@NgModule({
  declarations: [SafePipe, TimePipe, DateTimePipe],
  exports: [SafePipe, TimePipe, DateTimePipe],
})
export class UtilityModule {}
